import { Component, Input } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-detail-sidebar",
  templateUrl: "./detail-sidebar.component.html",
})
export class DetailSidebarComponent {
  // Google Maps directions link used on the map_col anchor.
  @Input() locationurl = "";
  // Map latitude.
  @Input() lat = 0;
  // Map longitude.
  @Input() lng = 0;
  // Full address shown in the tooltip.
  @Input() tcAddress: any;
  // Truncated address text shown beside the map pin.
  @Input() tcAddressShow: any;
  // Business / lunch hours object.
  @Input() workhours: any;
  // Test center view model driving phone, cross street, transport, parking and website.
  @Input() tcView: any;
  // alt text for the public-transport (bus) icon: desktop uses "noun-plus-img", mobile uses "bus-img".
  @Input() busAlt = "noun-plus-img";
  // Whether to render the extra Instagram + LinkedIn social icons (desktop only).
  @Input() showExtraSocial = false;

  // Returns the phone mask pattern for the given phone code (identical to DetailPageComponent.formateMask).
  formateMask(phonecode) {
    if (phonecode) {
      if (phonecode === "+91" || phonecode === +91) {
        return environment.indiaPhoneMask;
      } else {
        return environment.usPhoneMask;
      }
    }
  }
}
